module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABP0lEQVRYR+2XgU3DMBBF358A2KAbwAjtBmwAbMAIbMAIhQlgAzoCI5QNygSHTjhtlNqO7aJUSDmpUhU1fS//fLYizlw6M5+9gJl9AtcTCb1IenBWX2AHXEwk8CVpMRRYAv6Zot4leeKHBFqoZnYD7CRtW+4/ScDM7oG1CwCr7olqRZqmoAfveM0S1QIR+EkSVQIZeLNEscAA/g08Ac+B/Arche9V7SgSiMB9XC+BjwBdAT7Xvii9iiVGBWJwX/Fm5hJ7AUmbwW+LJLICKbg/YkwgXO/GsyiJpICZ3QJvIVLv+bI/6ymBmISkq9T+kBN4DIvsCJ5LoAP10vP7F5K8JUc11gLv8za21eYS6En8HjiZrXp0EaaiKxEo2ZZngTmBOYE5gTmBf52AHzSb8F7g7wdN1ZxAE632OP4rSO5/fgC4BdAhIVgyNAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/top.png
// module id = Uw9C
// module chunks = 56